import { FC } from 'react';

import { FormControl, Select, MenuItem } from '@mui/material';

import { SelectableArray } from '@type-def_common/SelectableArray';

import styles from './SelectBoxWrapper.module.scss';

type Props = {
  placeholder: string;
  selectList: SelectableArray;
  state: any;
  setState: any;
  onChangeFunction?: any;
  size?: string;
  classNames?: string;
  flexClassNames?: string;
  disabled?: boolean;
  dataTest?: string;
  dataTestId?: string;
  defaultValue?: string;
};

const SelectBoxWrapper: FC<Props> = ({
  placeholder,
  selectList,
  state,
  setState,
  onChangeFunction,
  size,
  classNames,
  flexClassNames,
  disabled,
  dataTest,
  dataTestId,
}) => {
  if (state === null) {
    state = '';
  }
  const handleSelect = (event: any) => {
    if (onChangeFunction) {
      onChangeFunction(event);
    } else {
      const {
        target: { value },
      } = event;
      setState(value);
    }
  };

  const disableClassName = Object.keys(selectList).length > 0 ? '' : styles.is_disable;
  return (
    <FormControl className={flexClassNames}>
      <Select
        placeholder={placeholder}
        disabled={disabled}
        displayEmpty
        value={state}
        onChange={handleSelect}
        renderValue={(value) => (value ? selectList[value] : <span className={styles.placeholder}>{placeholder}</span>)}
        className={`${styles.select} ${disableClassName} ${size === 'width1' && 'util-formWidth1'} ${
          size === 'width3' && 'util-formWidth3'
        } ${classNames}`}
        data-test={dataTest}
        data-testid={dataTestId}
      >
        {Object.keys(selectList).map((key) => (
          <MenuItem className={styles.menu_item} key={key} value={key}>
            {selectList[key]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectBoxWrapper;
